// extracted by mini-css-extract-plugin
export default {"canva":"ChartView_canva__HpZmb","label":"ChartView_label__kljpj"};